import * as React from "react"

import { cn, capitalizeWords } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onChange, autoCapitalize = true, ...props }, ref) => {
  // Types that should NOT be auto-capitalized
  const noCapitalizeTypes = ['email', 'password', 'url', 'number', 'tel', 'date', 'time', 'datetime-local'];
  const shouldCapitalize = autoCapitalize && !noCapitalizeTypes.includes(type);

  const handleChange = (e) => {
    if (shouldCapitalize && e.target.value) {
      // Capitalize words while preserving cursor position
      const cursorPos = e.target.selectionStart;
      const originalLength = e.target.value.length;
      e.target.value = capitalizeWords(e.target.value);
      const newLength = e.target.value.length;
      
      // Restore cursor position
      const newCursorPos = cursorPos + (newLength - originalLength);
      setTimeout(() => {
        if (e.target.setSelectionRange) {
          e.target.setSelectionRange(newCursorPos, newCursorPos);
        }
      }, 0);
    }
    
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      onChange={handleChange}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
